import * as basicLightbox from 'basiclightbox';
import '../../../node_modules/basiclightbox/dist/basicLightbox.min.css';

export default class TestModule {
  constructor(el) {
    const youtubeID = el.getAttribute('data-youtube-id')
    const instance = basicLightbox.create(`<div class="youtube-wrap"><iframe src="https://www.youtube.com/embed/${youtubeID}" autoplay width="560" height="315" frameborder="0"></iframe></div>`);
    el.addEventListener('click', function(event) {
      event.preventDefault();
      instance.show();
    })
  }
}